import $ from 'jquery';

$(window).on('resize load', function () {
	$('.js-circle').each(function () {
		let width = $(this).innerWidth();
		$(this).css('height', width);
	});
});
